import { render, staticRenderFns } from "./HomeTrendingTags.vue?vue&type=template&id=9301cc9a&"
import script from "./HomeTrendingTags.vue?vue&type=script&lang=js&"
export * from "./HomeTrendingTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports